<div class="policy-flow">
  <div class="flow-intro">
    <span class="flow-label">{{ 'policy-flow.title' | translate }}</span>
    <span class="flow-caption">{{ 'policy-flow.caption' | translate }}</span>
  </div>

  <div class="flow-steps">
    <ng-container *ngFor="let step of steps; let i = index; let last = last">
      <button
        type="button"
        class="flow-step"
        [class.active]="isActive(step.key)"
        [class.done]="isBefore(step.key)"
        (click)="go(step)"
        [attr.aria-current]="isActive(step.key) ? 'step' : null"
      >
        <span class="step-index">
          <i *ngIf="isBefore(step.key)" class="fa-solid fa-check"></i>
          <span *ngIf="!isBefore(step.key)">{{ i + 1 }}</span>
        </span>

        <span class="step-body">
          <span class="step-title">
            <i [class]="step.icon"></i>
            {{ step.title | translate }}
            <span class="step-count" *ngIf="countFor(step.key) !== null">{{ countFor(step.key) }}</span>
          </span>
          <span class="step-hint">{{ step.hint | translate }}</span>
        </span>
      </button>

      <span class="flow-arrow" *ngIf="!last" aria-hidden="true">
        <i class="fa-solid fa-chevron-right"></i>
      </span>
    </ng-container>
  </div>

  <!-- A sub-user with no role can open nothing, which is easy to miss -->
  <div class="flow-warning" *ngIf="unassignedWarning > 0">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>
      {{ unassignedWarning }}
      {{ (unassignedWarning === 1 ? 'policy-flow.unassigned-one' : 'policy-flow.unassigned-many') | translate }}
    </span>
    <a [routerLink]="'/home/roles-management'" [queryParams]="{ tab: 'users' }" class="flow-warning-link">
      {{ 'policy-flow.assign-now' | translate }}
      <i class="fa-solid fa-arrow-right"></i>
    </a>
  </div>
</div>
